module.exports = __webpack_public_path__ + "static/img/Awindows.301279c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Awindows.png
// module id = VAc5
// module chunks = 1